/*
  AVM Herbals — shared add-to-cart helper (Phase 8)
  ---------------------------------------------------------------------------
  One small, dependency-free helper used by the Bundle section, the Quick View
  modal and the mobile sticky ATC bar so they all add to cart the same way and
  open the same drawer.

  This theme renders <avm-cart-drawer> (sections/cart-drawer-avm.liquid) instead
  of Craft’s stock <cart-drawer>, so Craft’s product-form.js has no cart element
  to call renderContents() on. The AVM drawer instead listens for the Craft
  pub/sub `cartUpdate` event (assets/constants.js + pubsub.js, loaded site-wide)
  and refreshes + opens itself for any source other than 'avm-cart-drawer'.

  So: POST the line item(s) to /cart/add.js in a single request, then publish
  `cartUpdate` — the drawer takes it from there. If there is no drawer on the
  page (or pub/sub is unavailable) we fall back to navigating to the cart page
  so the add is always visible to the shopper.
*/
(function () {
  'use strict';

  if (window.AVMCart) return;

  function cartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function hasDrawer() {
    return !!document.querySelector('avm-cart-drawer');
  }

  /*
    Refresh + open the AVM cart drawer, then notify the remaining cart listeners.
    The drawer refresh is awaited so callers can surface a failure instead of
    reporting a successful add while stale cart contents remain on screen.
  */
  function notifyDrawer(cartData) {
    var drawer = document.querySelector('avm-cart-drawer');
    if (!drawer || typeof drawer.refreshSection !== 'function') return Promise.resolve(false);

    return drawer.refreshSection().then(function () {
      if (typeof drawer.open === 'function') drawer.open();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          var result = publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'avm-cart-drawer',
            cartData: cartData
          });
          if (result && typeof result.catch === 'function') result.catch(function () {});
        } catch (e) {
          /* The rendered drawer is already current; ancillary listeners are best-effort. */
        }
      }

      return true;
    });
  }

  window.AVMCart = {
    hasDrawer: hasDrawer,

    /*
      items: [{ id: <variantId>, quantity: <int> }, ...]
      Adds every line item in ONE request. Resolves with the /cart/add.js
      response, rejects with an Error (err.cart holds Shopify’s error body).
    */
    addItems: function (items) {
      return fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              var err = new Error((data && (data.description || data.message)) || 'Cart error');
              err.cart = data;
              throw err;
            }
            return data;
          });
        })
        .then(function (data) {
          return notifyDrawer(data).then(function (opened) {
            /* Nothing to open → send the shopper to the cart so the add is visible. */
            if (!opened) window.location = cartUrl();
            return data;
          }).catch(function () {
            /* The add succeeded but the drawer could not refresh; show the canonical cart instead. */
            window.location = cartUrl();
            return data;
          });
        });
    },

    /* Convenience for a single variant. */
    addVariant: function (variantId, quantity) {
      return this.addItems([{ id: variantId, quantity: quantity || 1 }]);
    }
  };
}());

/* Keep PDP media compact on phones while retaining the square desktop gallery. */
(function () {
  'use strict';
  var mobileGallery = window.matchMedia('(max-width: 749px)');

  function avmFixPdpHero() {
    document.querySelectorAll('.avm-gallery__hero').forEach(function (el) {
      el.style.aspectRatio = mobileGallery.matches ? '1.55 / 1' : '1 / 1';
    });
    document.querySelectorAll('.avm-gallery__parallax img').forEach(function (el) {
      el.style.objectFit = 'contain';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avmFixPdpHero);
  } else {
    avmFixPdpHero();
  }
  mobileGallery.addEventListener('change', avmFixPdpHero);
}());

/* Keep the sticky ATC available on desktop. Visibility is owned by the product
   section so one observer controls the bar and body state at every breakpoint. */
(function () {
  'use strict';
  function avmFixStickyAtc() {
    var stickyBar = document.querySelector('.avm-sticky-atc');
    if (!stickyBar) return;

    if (window.matchMedia('(min-width: 990px)').matches) {
      stickyBar.classList.add('avm-sticky-atc--desktop');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avmFixStickyAtc);
  } else {
    avmFixStickyAtc();
  }
}());
